"use strict";
(self["webpackChunk_folio_stripes_sample_platform"] = self["webpackChunk_folio_stripes_sample_platform"] || []).push([[57],{},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(moduleId))
/******/ __webpack_require__.O(0, [15], () => (__webpack_exec__(50981)));
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);